import React from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

const NegativeResponsesV2 = ({ questions, loading, isSite = false }) => {
  if (loading) {
    return (
      <div className="dashboard-v2__table-section">
        <Skeleton height={28} width={360} />
        <Skeleton height={220} className="mt-3" />
      </div>
    );
  }

  return (
    <section className="dashboard-v2__table-section">
      <h2 className="dashboard-v2__table-title">
        Top 10 Questions with <span>Negative Responses</span>
      </h2>
      <div className="dashboard-v2__table-wrap">
        <div className="table-responsive">
          <table className="table dashboard-v2__table mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Question</th>
                <th>{isSite ? "Site" : "Machine"}</th>
                <th>Negative Responses</th>
                <th>Tags</th>
              </tr>
            </thead>
            <tbody>
              {questions.map((question, index) => (
                <tr key={question.id}>
                  <td>{index + 1}</td>
                  <td className="dashboard-v2__question-cell">{question.title}</td>
                  <td>
                    <Link
                      to={isSite ? `/site-info/${question.machine.uuid}` : `/machine-info/${question.machine.uuid}`}
                      className="dashboard-v2__link"
                    >
                      {question.machine.name}
                    </Link>
                  </td>
                  <td>{question.negativeCount}</td>
                  <td>
                    <div className="sites-v2__tags">
                      {question.machine.tags?.map((item) => (
                        <span key={item.id} className="sites-v2__tag machines-v2__tag">
                          {item.name}
                        </span>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default NegativeResponsesV2;
